<template>
  <div :class="wrapperClasses">
    <div class="listing">
      <b-button @click="addQuestion" class="float-right" icon-left="plus" rounded>Add new question</b-button>
      <b-table
        :data="filteredItems"
        :row-class="(row, index) => assignRowClasses(row, index)"
        :draggable="true"
        @dragstart="dragstart"
        @drop="drop"
        @dragover="dragover"
        @dragleave="dragleave"
      >
        <template slot-scope="props">
          <b-table-column field="text" label="Question" sortable>
            <span class="question-text">{{props.row.text}}</span>
            <div v-if="hasParent(props.row)" class="depends-on">
              <span class="label">Depends on:</span>
              <em>{{parentValue(props.row.show)}}</em>
            </div>
          </b-table-column>
          <b-table-column field="options" label="Options" sortable>
            <ol>
              <li
                v-for="(opt, oi) in props.row.options"
                :key="['opt',props.row._id,oi].join('-')"
              >{{opt.text}}</li>
            </ol>
          </b-table-column>
          <b-table-column field="format" label="Type" sortable>{{props.row.type|toWords}}</b-table-column>
          <b-table-column field="active" label="Active" sortable>
            <b-icon :icon="props.row.active|activeIcon" />
          </b-table-column>
          <b-table-column field="weight" label="#" sortable>{{props.row.weight}}</b-table-column>
          <b-table-column field="_id" label="Edit">
            <span class="edit" v-on:click="showQuestion(props.row._id)">
              <b-icon icon="square-edit-outline" />
            </span>
          </b-table-column>
        </template>
      </b-table>
      <b-button @click="addQuestion" class="float-right" icon-left="plus" rounded>Add new question</b-button>
    </div>
    <QuestionDetail v-if="showDetail" :question="question" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getQuestions, sortQuestions } from "../api/methods";
import { hasObjectId } from "../api/helpers";
import { questionSchema } from "../store/schemas";
import filters from "../mixins/filters";
import QuestionDetail from "./QuestionDetail";
import { bus } from "../main";

export default {
  name: "QuestionList",
  components: {
    QuestionDetail
  },
  mixins: [filters],
  data() {
    return {
      items: [],
      num: 0,
      total: 0,
      perPage: 100,
      start: 0,
      showDetail: false,
      currId: "",
      question: {
        type: Object,
        default: questionSchema
      }
    };
  },
  created() {
    bus.$on("escape", val => {
      if (val) {
        this.close();
      }
    });
    bus.$on("media-item-removed", itemId => {
      if (itemId) {
        this.close();
      }
    });
  },
  mounted() {
    if (this.$route.path) {
      const parts = this.$route.path.substring(1).split("/");
      if (parts.length > 1) {
        this.currId = parts[1];
      }
    }
    this.mapQuestions();
    setTimeout(() => {
      this.mapQuestions();
    }, 500);
  },
  computed: {
    ...mapGetters(["questions"]),
    wrapperClasses() {
      let cls = ["questions"];
      if (this.showDetail) {
        cls.push("show-detail");
      }
      return cls;
    },
    numItems() {
      return this.questions.length;
    },
    filteredItems() {
      const items = this.items.filter(q => hasObjectId(q));
      items.sort((a, b) => a.weight - b.weight);
      return items;
    }
  },
  filters: {
    activeIcon(val) {
      return val === true ? "check" : "circle-off-outline";
    }
  },
  methods: {
    mapQuestions(remap) {
      if (this.items.length < 1 || remap === true) {
        getQuestions().then(data => {
          if (data.items instanceof Array) {
            this.items = data.items;
            this.items.sort((a, b) => a.weight - b.weight);
            if (this.currId.length > 3) {
              this.showQuestion(this.currId);
            }
          }
        });
      }
    },
    remapQuestions() {
      this.mapQuestions(true);
    },
    showQuestion(id) {
      const question = this.items.find(s => s._id === id);
      if (question instanceof Object) {
        this.question = question;
        const newPath = "/questions/" + id;
        if (this.$route.path !== newPath) {
          this.$router.push(newPath);
        }
        this.showDetail = true;
      }
    },
    hasParent(item) {
      if (item instanceof Object) {
        if (item.show) {
          if (item.show instanceof Object) {
            return item.show.key.length > 2;
          }
        }
      }
      return false;
    },
    parentValue(item) {
      let str = "";
      if (item instanceof Object && item.key) {
        const qp = this.items.find(q => q.key === item.key);
        if (qp) {
          str = qp.text;
          let val = item.value;
          switch (typeof item.value) {
            case "boolean":
              val = item.value ? "yes" : "no";
              break;
          }
          str += " => " + val;
        }
      }
      return str;
    },
    close() {
      this.showDetail = false;
      const newPath = this.$route.path
        .substring(1)
        .split("/")
        .shift();
      if (this.$route.path !== newPath) {
        this.$router.push(newPath);
      }
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      return cls.join(" ");
    },
    addQuestion() {
      let newQuestion = this.items.find(q => q._id === "new");
      if (!newQuestion) {
        newQuestion = questionSchema;
      }
      newQuestion._id = "new";
      newQuestion.key = "new_key";
      newQuestion.type = "radio";
      newQuestion.weight = this.items.length + 1;
      this.items.push(newQuestion);
      setTimeout(() => {
        this.showQuestion(newQuestion._id);
      }, 250);
    },
    update() {
      this.mapQuestions(true);
    },
    dragstart(payload) {
      this.draggingRow = payload.row;
      this.draggingRowIndex = payload.index;
      payload.event.dataTransfer.effectAllowed = "copy";
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = "copy";
      payload.event.target.closest("tr").classList.add("is-selected");
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest("tr").classList.remove("is-selected");
      payload.event.preventDefault();
    },
    drop(payload) {
      payload.event.target.closest("tr").classList.remove("is-selected");
      const droppedOnRowIndex = payload.index;
      let counter = 1;
      this.items = this.items.map(q => {
        if (q._id === this.draggingRow._id) {
          q.weight =
            this.draggingRowIndex < droppedOnRowIndex
              ? droppedOnRowIndex + 1.5
              : droppedOnRowIndex + 0.5;
        }
        return q;
      });
      this.items.sort((a, b) => a.weight - b.weight);
      this.items = this.items.map(q => {
        q.weight = counter;
        counter++;
        return q;
      });
      const weightData = this.items.map(item => {
        return {
          id: item._id,
          weight: item.weight
        };
      });
      sortQuestions(weightData);
      this.$buefy.toast.open(
        `Moved ${this.draggingRow.text} from row ${this.draggingRowIndex +
          1} to ${droppedOnRowIndex + 1}`
      );
    }
  }
};
</script>